<template style="">
  <div class="Game_vision">

    <div class="view" v-loading="loading">
      <div class="left">
          <!-- <img src="../images/视觉控制力.jpg" alt="" width="380" height="230"> -->
      </div>
      <div class="right">
        <h2>{{ info.GameName }}</h2>
        <!--<label>训练描述:</label>-->
        <p v-html="info.Guideline"></p>
        <div class="btn-group">
          <div v-if="network" class="btn-left">
            <button @click="startTests" class="btn">开始训练</button>
          </div>
          <div v-if="!network" class="btn-left">
            <h2><b><font color="red">网络断开，正在重新连接...</font></b></h2>
          </div>
        </div>
      </div>
    </div>

    <el-dialog style="display: none;" :show-close="false" :fullscreen="true" title="" :visible.sync="dialogVisible">
      <div class="stage" id="stage" ref="stage">
        <div v-if="!finished">
          <div class="left-box" ref="leftBox" style="display: flex;flex-direction: column;justify-content: center;">
            <div style="font-size: 22px;" ref="title" class="text-center mb-2" v-if="question == 0">
              请点掉{{ targetText }}的字
            </div>
            <div style="font-size: 22px;" ref="title" class="text-center mb-2" v-else>
              请点掉{{ targetText }}这个字
            </div>
            <div class="textbox" ref="textbox">
              <span @click="clickFn(item, index)" class="item" :class="item.active ? 'remove' : ''" :style="'color:' + item.color" v-for="(item, index) in newList" :key="index">{{ item.text }}</span>
            </div>
          </div>
          <div class="right-box">
            <div class="myDiv3_Main_right_1">
              <p class="my_right_gameName">{{ info.GameName }}</p>
              <div class="myDiv3_Main_right_info mytrain">状态：训练进行中</div>
              <div class="myDiv3_Main_right_info myerrorNum">剩余数：{{ surplusNum }}</div>
            </div>
            <div class="myDiv3_Main_right_2">
              <span class="my_right_font1">剩余时间</span>
              <span class="my_right_time">{{ timeSpan }}s</span>
            </div>
            <div class="myDiv3_Main_right_3">
              <input type="button" class="my_right_btn" value="提交" id="btnSubmit" @click="finish()">
              <input type="button" class="my_right_btn" value="重新开始" onclick="mySignOutGame();">
            </div>
          </div>
        </div>
        <div v-else style="font-size: 30px;padding-top: 14rem!important;" class="text-center pt-4 pb-5">
          <p style="font-size: 42px;">测试结束！</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      network: true, //默认有网
      count: 1,
      targetText: '',
      targetColor: '', //red
      question: 0,//有两种问题 0代表点掉某种颜色的字如红色的字,1代表点掉某个字，如红字，与颜色无关
      result: [],
      length: 0,
      list: [],
      newList: [],
      texts: ['红','绿','黄','紫','蓝'],
      colors: ['red','yellow','green','blue','purple'],
      timeSpan: 0, //游戏总时长
      startTime: 0,
      endTime: 0,
      PublishID: "",//发布ID
      reportID: "",
      startTimeDate: '', //开始日期时间
      endTimeDate: '',
      sumNum: 0, //需要点掉字数量
      alreadyNum: 0, //已经点掉的数量
      surplusNum: 0, //剩余点掉字数
      timeSpanTime: null,
      istest: false,//是否测试
      finished: false,
      loading: false,
      info: {CrossOut: "绿", GameName: "视觉控制力", Guideline: "屏幕上会出现五颜六色的代表颜色的字，<b><font color=\"red\">请按照要求点击去除相应的字</font></b>，如“点掉红这个字”或“点掉红色的字”。", Number: 25, ResultID1: null, TimeSpan: 0.5, Url1: "http://172.16.0.110:8003", Url2: "http://172.16.0.110:9004",
      },
      dialogVisible: false,
    }
  },
  mounted() {
    this.getApi();
  },
  filters: {
    toText(val) {
      let text = ''
      switch (val) {
        case 'red':
          text = '红'
          break
        case 'yellow':
          text = '黄'
          break
        case 'green':
          text = '绿'
          break
        case 'blue':
          text = '蓝'
          break
        case 'purple':
          text = '紫'
          break
      }
      return text
    }
  },
  methods: {
    //获取元素高度
    getGameHeight() {
      setTimeout(() => {
        let boxHeight = this.$refs.leftBox.offsetHeight;
        if (this.$refs.textbox.offsetHeight > boxHeight) {
          this.$refs.textbox.style.overflowX = 'scroll';
          this.$refs.textbox.style.height = this.$refs.textbox.offsetHeight - this.$refs.title.offsetHeight - 10 + 'px';
        }
      },5);
    },
    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      var fff = date.getMilliseconds() >= 100 ? date.getMilliseconds() : date.getMilliseconds() >= 10 ? '0' + date.getMilliseconds() : '00' + date.getMilliseconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    //游戏开始
    startTests() {
      if (this.question == 0) {
        if (!!window.android) window.android.getTitle("请点掉" + this.targetText + "的字");
      } else {
        if (!!window.android) window.android.getTitle("请点掉" + this.targetText + "这个字");
      }
      this.dialogVisible = true;
      this.startTime = new Date().getTime();
      this.startTimeDate = this.formatDate(this.startTime);
      this.countDown();
    },
     //时间倒数
    countDown() {
      this.timeSpanTime = setInterval(() => {
        this.timeSpan--;
        if (this.timeSpan === 0) {
          clearInterval(this.timeSpanTime);
          this.finish();
        }
      }, 1000);
    },
    toTextFn(val) {
      let text = '';
      switch (val) {
        case 'red':
          text = '红'
          break
        case 'yellow':
          text = '黄'
          break
        case 'green':
          text = '绿'
          break
        case 'blue':
          text = '蓝'
          break
        case 'purple':
          text = '紫'
          break
      }
      return text;
    },
    toColorFn(val) {
      let text = '';
      switch (val) {
        case '红':
          text = 'red'
          break
        case '黄':
          text = 'yellow'
          break
        case '绿':
          text = 'green'
          break
        case '蓝':
          text = 'blue'
          break
        case '紫':
          text = 'purple'
          break
      }
      return text;
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    },
    rand(min, max) {
      return Math.round(Math.random() * (max - min) + min);
    },
    copy(obj) {
      var newobj = obj.constructor === Array ? [] : {};
      if (typeof obj !== 'object') {
        return;
      }
      for (var i in obj) {
        newobj[i] = typeof obj[i] === 'object' ? this.copy(obj[i]) : obj[i];
      }
      return newobj
    },
    //模拟请求返回来数据
    getApi() {
      this.loading = false;
      this.length = 25;//出现字数
      this.targetText = "绿";//点掉字
      let crossOut = "绿".substring(0, 1);
      this.timeSpan = "0.5".TimeSpan * 60;//测试时长（分）res.data.Data.TimeSpan*60
      this.question = this.targetText.length > 1 ? 0 : 1;
      this.targetColor = this.toColorFn(crossOut);
      this.reportID = this.getUrlParam('UserID');
      this.PublishID = this.getUrlParam('PublishID');
      this.randText();
    },
    finish: function () {
      clearInterval(this.timeSpanTime);
      if (this.surplusNum > 0) this.leaveOutFun();
      this.count = 0
      this.submitData();
    },
    //遗漏函数
    leaveOutFun() {
      this.endTime = new Date().getTime();
      for (let i = 0; i < this.newList.length; i++) {
        let obj = {};
        obj.GameID = 'RZ-13';//游戏编号
        obj.ReportID = this.reportID;//报告编号
        obj.StartTime = this.startTimeDate;//开始时间
        obj.ReactionTime = 0;//反应时（毫秒）
        obj.EndTime = this.formatDate(this.endTime);//结束时间
        if (this.question === 1 && this.newList[i].text === this.targetText && !this.newList[i].active) {
          obj.No1 = this.result.length + 1;//序号
          obj.Result = '遗漏';//结果
          obj.CrossOut = this.toTextFn(this.newList[i].color) + '的' + this.targetText + '字';//点掉字
          if (this.result.length + 1 == 1) {
            obj.ReportID = obj.ReportID + "_" + this.PublishID;
          }
          this.result.push(obj);
        } else if (this.question === 0 && this.newList[i].color === this.targetColor) {
          obj.No1 = this.result.length + 1;//序号
          obj.Result = '遗漏';//结果
          obj.CrossOut = this.toTextFn(this.newList[i].color) + '的' + this.newList[i].text + '字';//颜色的字
          if (this.result.length + 1 == 1) {
            obj.ReportID = obj.ReportID + "_" + this.PublishID;
          }
          this.result.push(obj);
        }
      }
    },
    clickFn: function (item, index) {
      // if (this.count == 0) return;
      if (!item.active) {
        this.endTime = new Date().getTime();
        item.active = true;
        let obj = {}
        obj.GameID = 'RZ-13';//游戏编号
        obj.ReportID = this.reportID;//报告编号
        obj.StartTime = this.startTimeDate;//开始时间
        obj.No1 = this.result.length + 1;//序号
        obj.ReactionTime = this.endTime - this.startTime;//反应时（毫秒）
        obj.EndTime = this.formatDate(this.endTime);//结束时间
        if (this.question == 1) {
          obj.Result = item.text == this.targetText ? '正确' : '错误';//结果
          obj.CrossOut = this.toTextFn(item.color) + '的' + item.text + '字';//点掉字
          item.text === this.targetText.substring(0, 1) ? this.alreadyNum += 1 : this.alreadyNum += 0;
        } else {
          obj.Result = item.color === this.targetColor ? '正确' : '错误'
          obj.CrossOut = this.toTextFn(item.color) + '的' + item.text + '字';//点掉字
          item.color === this.targetColor ? this.alreadyNum += 1 : this.alreadyNum += 0;
          if (item.color === this.targetColor) this.newList.splice(index, 1)
        }
        this.surplusNum = this.sumNum - this.alreadyNum;
        if (this.result.length + 1 == 1) {
          this.istest = true;
          obj.ReportID = obj.ReportID + "_" + this.PublishID;
        }
        this.result.push(obj);
        //题目做完自动提交
        if (this.surplusNum == 0) this.finish();
      }
    },
    randText: function(){
      for (let i = 0; i < this.length; i++) {
        this.list.push({ color: this.colors[this.rand(0, this.colors.length - 1)], text: this.texts[this.rand(0, this.texts.length - 1)], active: false });
      }
      this.sizeColor(this.list);
      this.newList = this.copy(this.list);
    },
    //判断随机字的颜色是否有一个是点掉字的颜色
    sizeColor(list){
      let itemIs = list.some(item => {
        return this.question === 1 ? item.text === this.targetText.substring(0, 1) ? true : false : item.color === this.targetColor ? true : false;
      });
      if (itemIs === false) {
        this.question === 1 ? this.list[this.list.length - 2].text = this.targetText.substring(0,1) : this.list[this.list.length - 2].color = this.targetColor;
      }
      for (let j = 0; j < list.length; j++) {
        //0 某个颜色的字 1这个字
        if (this.question === 0 && list[j].color === this.targetColor) {
          this.sumNum += 1;
        }
        if (this.question === 1 && list[j].text === this.targetText.substring(0, 1)) {
          this.sumNum += 1;
        }
      }
      this.surplusNum = this.sumNum;
    },
    //重新开始
    myRestart() {
      if (!!window.android) window.android.getTitle("");
      clearInterval(this.timeSpanTime);
      this.list = [];
      this.result = [];
      this.sumNum = 0;
      this.alreadyNum = 0;
      this.surplusNum = 0;
      this.getApi();
      this.startTests();
    },
    submitData() {
      alert("完成");
    }
  }
}
</script>
<style>
  .Game_vision{width: 100%;height: 100%;}
  .textbox {position: relative;top: 0;margin-bottom: 1.5rem;overflow-x: scroll;display: flex;justify-content: space-around;align-items: center;flex-wrap: wrap;}
  .item {font-size: 50px;cursor: pointer;width: 20%;text-align: center;}
  .remove {opacity: 0.05;}
  .textbox::-webkit-scrollbar {display: none;}
</style>
